module.exports = __webpack_public_path__ + "img/财达证券.e7177bbf.png";